import React, { useState } from "react";
import "./Edit_Design_Cards.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { pincodeCheck } from "../../../../features/products/productsSlice";
import { deleteCart, getAllCart } from "../../../../features/cart/cartSlice";

function Edit_Design_Cards({ val }) {
  const [isActive, setIsActive] = useState(false);

  const toggleDropdown = () => {
    setIsActive((prev) => !prev);
  };
  const dispatch = useDispatch();
  const deletSubmit = async (data) => {
    // if()

    const res = await dispatch(deleteCart(data));
    dispatch(getAllCart());
    // if (res?.payload?.errors) {
    //     setError("pincode", {
    //         type: "manual",
    //         message: res.payload?.errors,
    //       });
    //   }else{
    //     setshowUploadModal(true);
    //   }
  };
  return (
    <div className="Edit_Design_Cards">
      <div className="row">
        <div className="col-md-3">
          <div className="img_card_holder">
            <div className="image-section">
              <img
                src={
                  process.env.REACT_APP_IMG_URL +
                  val?.Product?.Product_Images[0]?.image
                }
                className="shapes_cards_img"
                alt="shapes_cards_img"
              />
            </div>
            {/* <div className="text_holder">
              <p>Edit Design</p>
            </div> */}
          </div>
        </div>

        <div className="col-md-9">
          <div className="details-section">
            <div className="content_holder">
              <div className="heading_text_holder">
                <h3>{val?.Product?.name}</h3>
                <div className="delete_icon_div">
                  <FontAwesomeIcon
                    icon={faTrash}
                    onClick={() => deletSubmit(val?.id)}
                    className="icon"
                  />
                </div>
              </div>
              <p className="quantity">
                Quantity: {val?.Product_Combination?.Qty?.name}
              </p>

              {/* Clickable dropdown */}
              <div
                className="product-specs"
                onClick={toggleDropdown}
                style={{ cursor: "pointer" }}
              >
                <p>Product Specifications</p>
                <div className="dropdown_holder">
                  <FontAwesomeIcon
                    className={`drop_icon ${isActive ? "active" : ""}`}
                    icon={faAngleDown}
                  />
                </div>
              </div>

              {/* Show details table only if active */}
              {isActive && (
                <div className="details_table_holder">
                  <Table className="mb-0">
                    <tbody>
                      {val?.Product_Combination?.round_corner && (
                        <tr>
                          <td>Card Type</td>
                          <td> Rounded corner</td>
                        </tr>
                      )}
                      {val?.Product_Combination?.Orientation && (
                        <tr>
                          <td>Orientation</td>
                          <td>{val?.Product_Combination?.Orientation.name}</td>
                        </tr>
                      )}
                      {val?.Product_Combination?.Material && (
                        <tr>
                          <td>Material</td>
                          <td>{val?.Product_Combination?.Material.name}</td>
                        </tr>
                      )}
                      {val?.Product_Combination?.Size && (
                        <tr>
                          <td>Size</td>
                          <td>{val?.Product_Combination?.Size.name}</td>
                        </tr>
                      )}
                      {val?.Product_Combination?.Lamination && (
                        <tr>
                          <td>Lamination</td>
                          <td>{val?.Product_Combination?.Lamination.name}</td>
                        </tr>
                      )}
                      {val?.Product_Combination?.Envelope && (
                        <tr>
                          <td>Envelope</td>
                          <td>{val?.Product_Combination?.Envelope.name}</td>
                        </tr>
                      )}
                      {val?.Product_Combination?.PrintingLocation && (
                        <tr>
                          <td>Print</td>
                          <td>
                            {val?.Product_Combination?.PrintingLocation.name}
                          </td>
                        </tr>
                      )}
                      {val?.Product?.Shape && (
                        <tr>
                          <td>Shape</td>
                          <td>{val?.Product?.Shape.name}</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              )}

              <div className="item-total">
                <span>Item Total</span>
                <span className="price">
                  ₹{(Number(val?.Product_Combination?.total) || 0).toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Edit_Design_Cards;
